export default {
    "navigation": {
        "allWatchfaces": "Alle apps",
        "faq": "FAQ",
        "helpCenter": "Help en instructies",
        "newsletter": "Newsletter",
        "contact": "Contact",
        "weatherProvider": "Weer Provider",
        "tides": "Getijden",
        "colors": "Kleuren",
        "fonts": "Lettertypen"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Moderne Garmin-apps met geavanceerde functies voor al je activiteiten",
        "newBadge": "Nieuw",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Veelgestelde vragen",
        "subtitle": "Vind antwoorden op veelgestelde vragen over onze watchfaces",
        "tabs": {
            "search": "Zoeken",
            "categories": "Categorieën",
            "trending": "Trending"
        },
        "search": {
            "placeholder": "Zoek naar hulp...",
            "button": "Zoeken",
            "suggestions": "Populaire zoekopdrachten",
            "tips": {
                "title": "Zoektips",
                "keywords": "Gebruik specifieke trefwoorden zoals \"GPS\", \"weer\" of \"instellingen\"",
                "language": "Zoeken werkt in je geselecteerde taal",
                "categories": "Blader door categorieën voor georganiseerde hulp"
            }
        },
        "noResults": {
            "title": "Geen resultaten gevonden",
            "description": "Probeer andere trefwoorden of blader door categorieën",
            "browseCategories": "Blader door categorieën"
        },
        "suggestions": {
            "title": "Populaire zoekopdrachten"
        },
        "trending": {
            "title": "Trending zoekopdrachten"
        },
        "categories": {
            "title": "Bladeren per categorie",
            "items": "items",
            "allItems": "Alle FAQ-items",
            "allItemsDescription": "Blader alle veelgestelde vragen",
            "noItems": {
                "title": "Geen items in deze categorie",
                "description": "Probeer een andere categorie te selecteren"
            },
            "viewMore": "Alle items bekijken"
        },
        "results": {
            "title": "Zoekresultaten",
            "found": "resultaten gevonden voor",
            "total": "Totaal resultaten",
            "bestMatch": "Beste match",
            "categories": "Categorieën",
            "sortBy": "Sorteren op",
            "sort": {
                "relevance": "Relevantie",
                "priority": "Prioriteit",
                "category": "Categorie"
            },
            "lastUpdated": "Laatst bijgewerkt",
            "matchedIn": "Gevonden in",
            "footer": "Heb je niet gevonden wat je zocht?",
            "browseCategories": "Blader door categorieën",
            "viewTrending": "Trending bekijken",
            "contactSupport": "Contact opnemen met support"
        },
        "actions": {
            "copy": "Kopiëren",
            "share": "Delen",
            "copyAnswer": "Antwoord kopiëren",
            "copyAll": "Alles kopiëren"
        },
        "loading": "FAQ's worden geladen...",
        "error": "Fout bij laden",
        "retry": "Opnieuw proberen"
    },
    "guides": {
        "backToHelp": "Terug",
        "purchase": {
            "title": "Aankoop en installatie",
            "tabs": {
                "installation": "Installatie",
                "versions": "VX / Elite versies",
                "troubleshooting": "Probleemoplossing"
            },
            "installation": {
                "title": "Watchfaces installeren via ConnectIQ-app",
                "intro": "Watchfaces kunnen op het horloge worden geïnstalleerd via de Garmin ConnectIQ-app voor Android of iOS.",
                "step1": "Verbind je horloge via Bluetooth met je telefoon en open de ConnectIQ-app op de telefoon.",
                "step2": "Navigeer naar de pagina van de watchface die je wilt installeren.",
                "step3": "Tik op de knop \"Installeren\". De watchface wordt in de downloadwachtrij geplaatst en op je horloge geïnstalleerd.",
                "step4": "Na installatie zie je een bericht in de app of op het horloge en is de watchface beschikbaar op je apparaat.",
                "noteScreen": "Zorg dat het scherm van je telefoon niet uitgaat en dat de ConnectIQ-app open blijft tijdens installatie en updates.",
                "selectWatchfaceTitle": "Watchface selecteren op het horloge",
                "selectWatchfaceIntro": "Als de watchface is geïnstalleerd maar nog niet zichtbaar is, moet je deze mogelijk in het systeemmenu van je horloge selecteren.",
                "select1": "Druk en houd de menuknop op je horloge ingedrukt (of de bijbehorende knop op touchscreen-apparaten) om het systeemmenu te openen.",
                "select2": "Navigeer naar het menu-item \"Watch Faces\" of \"Displayontwerpen\".",
                "select3": "Je ziet een lijst van alle geïnstalleerde watchfaces. Gebruik de omhoog/omlaag-knoppen of het touchscreen om te navigeren.",
                "select4": "Bevestig de geselecteerde watchface met de knop rechtsboven. De watchface is nu actief op je horloge."
            },
            "versions": {
                "title": "VX vs Elite – wat is het verschil?",
                "sameFeatures": "Technisch zijn beide versies identiek en bieden ze dezelfde functies. Het enige verschil is hoe ze worden gekocht en geactiveerd.",
                "eliteTitle": "Elite-versie (Garmin Pay)",
                "elite1": "Aparte installatie van de watchface die direct via Garmin Pay in de ConnectIQ Store is gekocht.",
                "elite2": "De Elite-versie is gekoppeld aan je Garmin-account. Als je een nieuw horloge koopt, kun je de Elite watchface opnieuw installeren zonder extra sleutel.",
                "elite3": "Garmin Pay wordt niet op alle horlogemodellen ondersteund en is mogelijk niet in alle landen beschikbaar.",
                "eliteNoKey": "Belangrijk: Bij aankoop van een Elite-versie via Garmin Pay wordt geen ontgrendelcode verzonden. De Elite-versie wordt direct na aankoop ontgrendeld en vereist geen code.",
                "vxTitle": "VX / Websiteversie",
                "vx1": "Compatibel met een groter aantal apparaten en vaak beschikbaar ook wanneer Garmin Pay dat niet is.",
                "vx2": "Bevat een ingebouwde gratis proefperiode van enkele dagen.",
                "vx3": "Na de proefperiode kun je op deze website een ontgrendelcode kopen om de VX-versie (of de pro-functies) permanent te ontgrendelen.",
                "vx4": "De ontgrendelcode is alleen geldig voor het apparaat waarvoor deze is gekocht (WatchfaceID).",
                "vx5": "Als je horloge door Garmin onder garantie wordt vervangen, kan een nieuwe sleutel worden gegenereerd. Neem in dat geval contact op via het contactformulier."
            },
            "website": {
                "title": "Aankoop via website (VX / normale versies)",
                "step1": "Installeer eerst de watchface op je horloge (zie tabblad Installatie). De WatchfaceID verschijnt pas in de watchface-instellingen na installatie.",
                "step2": "Open de watchface-instellingen (via ConnectIQ-app of Garmin Express) en kopieer de WatchfaceID uit het bovenste veld.",
                "step3": "Selecteer op deze website de bijbehorende watchface en voer je WatchfaceID in het aankoopformulier in.",
                "step4": "Voltooi de betaling. Je ontvangt de ontgrendelcode per e-mail en kunt deze invoeren in het sleutelveld van de watchface-instellingen.",
                "noteNoAutoInstall": "Belangrijk: Het kopen van een ontgrendelcode via de website installeert de watchface niet automatisch op je horloge. De bovenstaande installatiestappen moeten handmatig worden uitgevoerd."
            },
            "troubleshooting": {
                "installationTitle": "Installatieproblemen (wachtrij / vastgelopen updates)",
                "installationIntro": "Soms mislukt de installatie, blijft de watchface lang in de wachtrij staan of meldt de ConnectIQ-app eindeloze updates.",
                "installationCause": "Dit heeft meestal te maken met de ConnectIQ-app of Garmin-services en niet met de watchface zelf.",
                "installationFix1": "Herstart je horloge en herstart de ConnectIQ-app op je telefoon.",
                "installationFix2": "Probeer de installatie opnieuw en zorg dat het telefoonscherm niet uitgaat en de ConnectIQ-app open blijft tijdens het proces.",
                "garminPayTitle": "Garmin Pay-aankoop blijft \"bezig\"",
                "garminPayText": "Als een Garmin Pay-aankoop in de ConnectIQ Store lang in een \"bezig\"-status blijft, wordt dit volledig door Garmin afgehandeld. Als ontwikkelaar hebben we geen invloed op het Garmin Pay-systeem. Neem in dat geval contact op met de officiële Garmin-ondersteuning.",
                "noKeyTitle": "Ik heb geen ontgrendelsleutel ontvangen na website-aankoop",
                "noKey1": "Controleer eerst de spammap van je e-mailinbox. E-mails met sleutels belanden daar vaak.",
                "noKey2": "In veel gevallen voorkomt een typfout in het e-mailadres de levering. Als je de e-mail niet kunt vinden, neem dan contact met ons op.",
                "noKey3": "en vermeld het e-mailadres dat je voor betaling hebt gebruikt en indien mogelijk de WatchfaceID.",
                "noKeyElite": "Let op: Bij aankoop van een Elite-versie direct via Garmin Pay in de ConnectIQ Store wordt geen ontgrendelcode verzonden. De Elite-versie wordt direct na aankoop ontgrendeld en vereist geen code."
            },
            "contactLink": "Contactformulier"
        },
        "timezones": {
            "title": "Tijdzones en UTC-offset",
            "basicsTitle": "Wat zijn de 2e en 3e tijdzone?",
            "basicsText": "In veel watchfaces kun je twee extra tijdzones instellen. Ze heten meestal \"Tweede tijdzone\" en \"Derde tijdzone\" en worden weergegeven in aparte velden op het horloge.",
            "offsetTitle": "UTC-offsets configureren",
            "offsetIntro": "In de watchface-instellingen is er meestal een veld waar je de offsets van de tweede en derde tijdzone in minuten ten opzichte van UTC kunt invoeren.",
            "offsetFormat": "De eerste waarde is de offset voor de tweede tijdzone, de tweede waarde voor de derde. Waarden worden in minuten gegeven, gescheiden door een spatie. Een plusteken wordt niet automatisch toegevoegd, dus positieve waarden moeten zonder + worden ingevoerd.",
            "exampleLabel": "Voorbeeld:",
            "exampleExplanation": "Hier gebruikt de tweede tijdzone een offset van -4,5 uur (−270 minuten) en de derde een offset van +2 uur (+120 minuten), altijd ten opzichte van UTC.",
            "changeExample": "Als je de tweede tijdzone wilt wijzigen naar +6 uur, moet de eerste waarde 360 zijn (6 × 60). Met het bovenstaande voorbeeld zou dat resulteren in:",
            "advancedTitle": "Geavanceerde opties (A/B/C-achtervoegsel)",
            "advancedOptionalHint": "Deze sectie is optioneel. Alleen relevant als je watchface de A/B/C-formaatachtervoegsels ondersteunt.",
            "advancedIntro": "Of je watchface deze achtervoegsels ondersteunt, staat in de beschrijving boven het offsetveld in de watchface-instellingen. Zo ja, zie je mogelijk een beschrijving vergelijkbaar met:",
            "advancedExample": "UTC 2e en 3e tijdzone offset in minuten (scheiden met spatie) (letters na de offsets: A - 12u-formaat, B - 24u-formaat, C - militair formaat, leeg - standaard)",
            "advancedNote": "Deze optionele letters (A/B/C) bepalen het weergaveformaat van de respectievelijke tijdzone in sommige watchfaces. Gebruik ze alleen als de watchface-beschrijving ze vermeldt.",
            "exampleSectionTitle": "Stap voor stap: Voorbeeld voor verschillende steden en formaten",
            "exampleIntro": "Het volgende voorbeeld laat zien hoe je een 2e tijdzone (bijv. New York) en een 3e (bijv. Tokyo) instelt, en optioneel 12u- of 24u-weergave per zone kiest.",
            "exampleStep1Title": "Stap 1: UTC-offset voor de 2e tijdzone",
            "exampleStep1Text": "Kies de stad of regio voor de 2e tijdzone. Zet het tijdsverschil met UTC om in minuten. Bijv.: New York (EST, UTC−5) → −300 minuten. Voer deze waarde als eerste in het veld in.",
            "exampleStep2Title": "Stap 2: UTC-offset voor de 3e tijdzone",
            "exampleStep2Text": "Hetzelfde voor de 3e tijdzone. Bijv.: Tokyo (JST, UTC+9) → 540 minuten. Dat is de tweede waarde, gescheiden door een spatie van de eerste.",
            "exampleOnlyOffsets": "Als je watchface geen A/B/C-achtervoegsels gebruikt, ben je klaar. Voer in:",
            "exampleStep3Title": "Stap 3: Optioneel formaatachtervoegsel (A/B/C)",
            "exampleStep3Optional": "Deze stap is optioneel: je kunt de achtervoegsels weglaten ook als de watchface ze ondersteunt; dan wordt het standaardformaat gebruikt. Om 12u, 24u of militair per zone te forceren, zet je de letter direct achter de offset — geen spatie tussen offset en achtervoegsel.",
            "exampleStep3Text": "Voorbeeld: 12-uursformaat voor New York (A) en 24-uurs voor Tokyo (B):",
            "exampleStep3Note": "Geen achtervoegsel = standaardweergave van de watchface (vaak 24u). Of achtervoegsels worden ondersteund, staat in de beschrijving boven het offsetveld in de watchface-instellingen.",
            "exampleFormatTitle": "Hoe de tijd wordt weergegeven met A, B, C",
            "exampleFormatIntro": "Voor hetzelfde tijdstip verschilt de weergave per formaat (bijv. 2e zone New York -300, 3e zone Tokyo 540). Live-voorbeeld:",
            "zone2": "2e zone",
            "zone3": "3e zone",
            "exampleTableTitle": "Referentie: UTC-offsets voor enkele steden (minuten)",
            "exampleTableIntro": "Standaardtijd; zomertijd kan afwijken. Vermenigvuldig uren met 60."
        },
        "switchViews": {
            "title": "Wisselweergaven en gebarenbediening",
            "wordLabel": "wisselweergave",
            "basicsTitle": "Wat zijn wisselweergaven?",
            "basicsText": "Veel watchfaces kunnen verschillende informatie in hetzelfde schermgebied tonen. Deze alternatieve pagina's heten vaak \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Bovenweergave 1/2\", \"Onderweergave 1/2\" of iets dergelijks in de watchface-instellingen.",
            "proNote": "In veel gevallen zijn deze extra weergaven pro-functies die tijdens de proefperiode beschikbaar zijn en daarna een activatiesleutel vereisen.",
            "gestureTitle": "Weergaven wisselen met een polsgebaar",
            "gestureIntro": "Op horloges zonder compatibel touchscreen kunnen de alternatieve weergaven worden gewisseld met een tweede polsbeweging.",
            "gestureStep1": "Hef je pols zoals gewoonlijk om het display te activeren. De seconden of het verlichte scherm geven aan dat het horloge in actieve modus is.",
            "gestureStep2": "Binnen een paar seconden (ongeveer 7) voer je de polsbeweging opnieuw uit – niet te abrupt, maar duidelijk genoeg zodat het horloge het herkent.",
            "gestureStep3": "Als de watchface wisselweergaven ondersteunt, veranderen de geconfigureerde gebieden (bijv. boven- of onderweergave) naar de volgende pagina.",
            "gestureHint": "Als er niets verandert, controleer de watchface-instellingen: sommige weergaven moeten expliciet worden toegewezen (bijv. \"Bovenweergave 2\" / \"Onderweergave 2\").",
            "touchTitle": "Wisselweergaven op touchscreen-apparaten",
            "touchIntro": "Op nieuwere horloges met compatibel touchscreen (bijv. Fenix 7 en nieuwer) kunnen weergaven vaak ook worden gewisseld door op specifieke touchzones te drukken.",
            "touchConfig": "In veel watchfaces kun je deze zones in de instellingen configureren, vaak verder naar beneden. Typische voorbeelden zijn de cijfers van uur en minuut of aparte gebieden op het display.",
            "touchHold": "Als een touchzone is geconfigureerd, schakelt een lange druk op het betreffende cijfer/gebied de toegewezen weergave.",
            "touchMultiple": "Sommige watchfaces bieden meerdere zones die apart kunnen worden toegewezen – bijvoorbeeld één voor de bovenweergave en één voor de onderweergave.",
            "touchInfo": "Als er speciale zones bestaan voor een watchface, worden deze meestal beschreven in de infotekst van de watchface op deze website of in de ConnectIQ Store."
        },
        "findWfId": {
            "title": "Je WatchfaceID vinden",
            "whatIs": "Wat is de WatchfaceID?",
            "whatIsExplanation": "Elke watchface heeft een unieke WatchfaceID per apparaat. Het is een 5-6 cijferig nummer. Deze ID is nodig voor het kopen van een activatiecode of voor ondersteuning.",
            "connectIqTitle": "Via ConnectIQ-app (aanbevolen)",
            "ciq1": "Zorg dat je horloge via Bluetooth met je telefoon is verbonden.",
            "ciq2": "Open de ConnectIQ-app op je telefoon.",
            "ciq3": "Navigeer naar de watchface-pagina waar je de beschrijving en afbeeldingen ziet. Als je die niet vindt, gebruik de \"Zoeken\"-balk onderaan of kijk onder \"Mijn watchfaces\" in de sectie \"Apparaat\".",
            "ciq4": "Druk op de knop \"Instellingen\" op de watchface-pagina om alle instellingen te openen.",
            "ciq5": "De WatchfaceID staat in het bovenste veld. Kopieer of typ dit nummer – dit is de ID die voor betaling nodig is.",
            "keyEntryTitle": "Activatiesleutel invoeren",
            "keyEntryExplanation": "In de regel onder het WatchfaceID-veld vind je het veld voor de sleutel/code die na betaling wordt verzonden. Sommige watchfaces tonen daar de resterende proefdagen – verwijder dit voordat je je sleutel invoert.",
            "garminExpressTitle": "Via Garmin Express (desktop)",
            "ge1": "Installeer Garmin Express en verbind je horloge met de computer.",
            "ge2": "Ga naar de lijst met geïnstalleerde watchfaces.",
            "ge3": "Klik op de knop met drie puntjes naast de watchface om instellingen te openen.",
            "ge4": "Volg dezelfde stappen als bij de ConnectIQ-app.",
            "geNote": "Let op: Het gebruik van de ConnectIQ-app wordt aanbevolen, omdat sommige Garmin Express-versies fouten kunnen veroorzaken.",
            "zeroId": "WatchfaceID toont 0?",
            "zeroIdExplanation": "Soms toont de WatchfaceID 0. Dit kan meestal worden opgelost door de instellingen eenmaal op te slaan of het horloge te herstarten. Als het daarna nog steeds 0 toont, zou het toch moeten werken voor betaling."
        },
        "location": {
            "title": "GPS- en locatie-instelling",
            "whatIsGpsFix": "Wat is een GPS-fix?",
            "gpsFixExplanation": "Een GPS-fix vertelt je watchface waar je bent zodat deze zonsopkomst/zonsondergang, maanfasen, weerlocatie en getijden correct kan berekenen.",
            "howTo": "Hoe een GPS-fix uitvoeren",
            "step1": "Navigeer op je horloge naar het startscherm van een activiteit (bijv. \"Hardlopen\")",
            "step2": "Wacht tot het horloge een GPS-signaal heeft (groene balk/icoon)",
            "step3": "Keer terug naar het horloge – gegevens zouden binnen een paar minuten moeten updaten",
            "alternative": "Alternatief: telefoon-GPS",
            "alternativeExplanation": "Je kunt ook GPS op je telefoon activeren. Het horloge moet via Bluetooth zijn verbonden. Deze methode is langzamer maar werkt net zo goed.",
            "requirements": "Vereisten",
            "req1": "Horloge verbonden met telefoon via Bluetooth",
            "req2": "Garmin Connect-app (niet ConnectIQ) draait minimaal op de achtergrond",
            "req3": "GPS ingeschakeld op telefoon voor telefoon-gebaseerde locatie"
        },
        "settings": {
            "tabs": { "options": "Opties gegevensvelden", "change": "Instellingen wijzigen", "troubleshoot": "Problemen oplossen" },
            "title": "Watchface-instellingen",
            "optionsIntro": "Algemene lijst van alle opties voor gegevensvelden. Klik voor de beschrijving. Niet alle opties zijn op alle watchfaces beschikbaar.",
            "change": {
                "title": "Hoe watchface-instellingen wijzigen",
                "intro": "Watchface-instellingen wijzig je via de ConnectIQ-app op je telefoon.",
                "step1": "Verbind het horloge via Bluetooth met je telefoon en open de ConnectIQ-app (niet Connect).",
                "step2": "Ga naar de pagina van het watchface. Als het nog niet is geïnstalleerd, installeer het eerst.",
                "step3": "Op de watchface-pagina vind je de knop \"Instellingen\"; tik om de lijst te openen.",
                "step4": "Hier kun je alle gegevensvelden, kleuren en geavanceerde opties wijzigen.",
                "step5": "Tik op de opslaan-knop rechtsboven om de instellingen naar het horloge te sturen.",
                "installLink": "Installatiehandleiding"
            },
            "troubleshoot": {
                "title": "Problemen oplossen",
                "cantSave": { "q": "Instellingen kunnen niet worden opgeslagen", "a1": "Soms hebben Garmin-servers moeite met bepaalde tekens.", "a2": "Maak het kleurenthema-veld leeg (als aanwezig) en sla opnieuw op." },
                "wontOpen": { "q": "Instellingen openen niet", "a1": "Sluit de ConnectIQ-app volledig en herstart het horloge indien nodig.", "a2": "Als je alleen een \"Installeren\"-knop ziet, is het watchface nog niet geïnstalleerd." },
                "missingOptions": { "q": "Ik vind een bepaalde instelling niet", "a": "Niet alle opties zijn op alle apparaten beschikbaar." },
                "naValue": { "q": "Een veld toont alleen \"n/a\"", "a": "Je apparaat ondersteunt deze optie niet (ouder model of ontbrekende hardware)." }
            }
        },
        "dateFormat": {
            "title": "Aangepast datumformaat (Datum 1 / 2 / 3)",
            "basicsTitle": "Waar zijn de datumformaatvelden voor?",
            "basicsIntro": "In de watchface-instellingen staan twee velden (of drie) om in te stellen hoe Datum 1, Datum 2 en eventueel Datum 3 worden weergegeven. De letters die je invoert bepalen het formaat.",
            "notAll": "Niet op alle watchfaces beschikbaar.",
            "where": "De velden staan meestal lager in de instellingen, onder de opties voor gegevensvelden.",
            "codesTitle": "Formatcodes",
            "codesIntro": "Je kunt de volgende letters gebruiken. De uitvoer komt overeen met de huidige datum.",
            "codeD": "dag van de maand (met leading zero)",
            "codeDText": "dag als tekst (bijv. maandag)",
            "codeM": "maand in cijfers (met leading zero)",
            "codeMText": "maand als tekst",
            "codeY": "jaar twee cijfers",
            "codeY4": "jaar vier cijfers",
            "codeJ": "Juliaanse datum (militair)",
            "codeW": "weeknummer",
            "codeO": "maand zonder leading zero",
            "codeN": "dag zonder leading zero",
            "codeP": "dag van het jaar",
            "exampleHint": "Bijv. \"D, d.M.Y\" kan \"ma, 27.02.2026\" tonen."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Hoe werken thema's?:",
            "description": "Bovenaan je watchface-instellingen heb je een \"themastring\" die je huidige kleurinstellingen (voor iconen, grafiek, tijd enz.) van je watchface vertegenwoordigt. Als je iets wijzigt (zoals de kleur van het bovenste gedeelte) en op \"Opslaan\" drukt, werkt de themastring zich bij de volgende keer dat je de instellingen opent bij. Zo kun je je kleurinstellingen bewaren door de themastring te kopiëren en ergens anders op te slaan. Je kunt hem zelfs delen met anderen, bijvoorbeeld in de beoordelingen/forum, en andermans themastring toepassen om andere stijlen uit te proberen."
        },
        "dynamicThemeSwitching": {
            "title": "Dynamisch thema wisselen:",
            "sunset": {
                "title": "Wisselen na zonsondergang / vóór zonsopkomst -",
                "description": "als je een uitroepteken ! voor de themastring zet die je wilt wisselen in het themastring-veld, wordt deze opgeslagen als het thema waarnaar wordt gewisseld na zonsondergang (voorbeeld: !UEUE[UEUEEEEEEU^). Je kunt het altijd wijzigen door een themastring met een vooraanstaand uitroepteken ! in het themastring-veld te zetten. Als je de themastring voor 's nachts wilt verwijderen, zet dan alleen een uitroepteken ! in het themastring-veld en dan wisselt het niet meer."
            },
            "lowPower": {
                "title": "Wisselen in energiebesparing -",
                "description": "het is hetzelfde proces als het instellen van een thema voor zonsondergang/zonsopkomst hierboven, maar in plaats van een ! zet je een # voor je themastring (voorbeeld: #UEUE[UEUEEEEEEU^). Elk horloge gaat na ongeveer 10 seconden kijken naar het horloge of terugkomen van een menu in een \"Energiebesparingsmodus\". Meestal verdwijnen de seconden standaard in energiebesparing (kan worden gewijzigd in de watchface-instellingen). Beide wisselopties (@nacht/@energiebesparing) kunnen worden gecombineerd. Eenmaal ingesteld is een dynamische themastring niet zichtbaar in je watchface-instellingen, dus bewaar hem ergens anders als je in de toekomst wijzigingen wilt aanbrengen."
            }
        }
    },
    "helpCenter": {
        "title": "Help en instructies",
        "subtitle": "Antwoorden, handleidingen en instructies voor je watchface",
        "guidesTitle": "Handleidingen en instructies",
        "faqTitle": "Veelgestelde vragen",
        "allCategories": "Alles",
        "guides": "Handleidingen",
        "faqResults": "FAQ",
        "noResults": "Geen resultaten gevonden",
        "noResultsHint": "Probeer andere zoekwoorden of blader door de categorieën en handleidingen hieronder."
    },
    "watchfacesOverview": {
        "title": "Alle apps",
        "loading": "Watchfaces laden...",
        "error": "Fout bij laden watchfaces",
        "retry": "Opnieuw proberen",
        "noWatchfaces": "Geen watchfaces beschikbaar"
    },
    "detailTabs": {
        "payment": "Betaling",
        "themes": "Thema's",
        "info": "Info",
        "instructions": "Instructies",
        "instructionsIntro": "Alle handleidingen en instructies in één oogopslag:",
        "noThemes": "Geen kleurenthema's beschikbaar voor dit watchface."
    },
    "watchfaceDetail": {
        "loading": "Watchface laden...",
        "error": {
            "notFound": "Watchface niet gevonden",
            "loading": "Fout bij laden watchface"
        },
        "backToOverview": "Terug naar overzicht",
        "goToStore": "Naar IQ Store",
        "goToTrial": "Proefversie",
        "devices": "apparaten",
        "info": {
            "title": "Functies",
            "tides": "🌊 Getijdeninformatie met automatische updates",
            "weather": "🌤️ Weergegevens van OpenWeatherMap en Yr",
            "colors": "🎨 Kleurenthema's en aanpassingen",
            "location": "📍 Locatie via GPS",
            "faq": "❓ FAQ en ondersteuning",
            "weatherFallback": "Zonder One Call 3.0-abonnement gebruikt de OpenWeatherMap API-sleutel de \"Yr\"-aanbieder als fallback."
        }
    },
    "colorThemes": {
        "clickToCopy": "Klik om te kopiëren",
        "clickToPreview": "Klik voor voorvertoning",
        "closePreview": "Voorvertoning sluiten",
        "copied": "Gekopieerd!",
        "useInSettings": "Gebruik in je watchface-instellingen",
        "guideLink": "Meer over thema's en themastrings",
        "deviceNote": "Kleurenthema's zijn niet op alle apparaten beschikbaar.",
        "noFieldNote": "Als je watchface-instellingen geen apart veld hebben voor kleurthema's, worden deze niet ondersteund voor jouw horlogemodel op dit watchface."
    },
    "payment": {
        "option1": {
            "title": "Optie 1: Garmin Pay",
            "description": "Koop het betaalde watchface via Garmin Pay in de ConnectIQ Store (als je horloge wordt ondersteund).",
            "link": "Link naar ConnectIQ Store"
        },
        "option2": {
            "title": "Optie 2: Directe betaling via WatchfaceID",
            "description": "Als je horloge niet door de Pro-versie wordt ondersteund, kun je een Trial/VX-sleutel kopen door je WatchfaceID in te voeren.",
            "vxNote": "Dit is een sleutel voor de VX-versie van het watchface, niet de Garmin Pay-versie!",
            "vxLink": "Link naar VX-versie"
        },
        "tax": "BTW",
        "wfid": {
            "description": "Voer je WatchfaceID in (te vinden in je watchface-instellingen)",
            "placeholder": "Voer WatchfaceID in (5-6 cijfers)",
            "guideLink": "Hoe vind ik mijn WatchfaceID",
            "guideLinkShort": "Instructies tonen"
        },
        "wfidError": {
            "letters": "WatchfaceID mag alleen cijfers bevatten",
            "tooLong": "WatchfaceID moet 5-6 cijfers zijn",
            "invalid": "Voer een geldige WatchfaceID in (5-6 cijfers)",
            "lengthHint": "Een WatchfaceID is meestal 5-6 cijfers. Controleer."
        },
        "errors": {
            "empty": "Voer je WatchfaceID in",
            "invalid": "Voer een geldige WatchfaceID in",
            "config": "Fout in betalingsconfiguratie",
            "checkout": "Betaling kon niet worden geopend. Probeer opnieuw."
        },
        "buy": "Nu kopen",
        "selectMethod": "Kies je versie",
        "versionSelectHint": "Dit zijn twee aparte versies — selecteer de juiste:",
        "vxWarning": "De VX- en Elite-versie zijn elk apart downloadbare versies van de wijzerplaat. Een activeringscode voor de VX-versie ontgrendelt NIET de Elite-versie.",
        "beta": {
            "title": "Momenteel in bèta",
            "description": "Tijdens deze bètafase kun je dit watchface volledig gratis gebruiken. Er worden geen automatische kosten in rekening gebracht na de testperiode. In deze periode worden nieuwe functies en verbeteringen getest. Bedankt voor je feedback!",
            "descriptionApp": "Tijdens deze bètaphase kun je de app volledig gratis gebruiken. Na de testperiode volgen er geen automatische kosten. In deze fase worden nieuwe features en functies getest. Bedankt voor jullie feedback!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite-versie",
            "description": "Dit watchface is alleen via Garmin Pay in de ConnectIQ Store verkrijgbaar.",
            "comboDescription": "Koop via Garmin Pay in de ConnectIQ Store. Aparte, standalone versie.",
            "compatibility": "Garmin Pay wordt niet op alle horloges ondersteund. Controleer compatibiliteit op de Store-pagina. Anders download de VX-versie (technisch identiek).",
            "storeLink": "Openen in ConnectIQ Store",
            "moreGuide": "Meer over het verschil Elite / VX?",
            "moreGuideLink": "Lees de koop- en installatiehandleiding",
            "eliteNoKey": "Bij aankoop van een Elite-versie via Garmin Pay wordt geen ontgrendelcode verzonden. De Elite-versie is direct na aankoop ontgrendeld en heeft geen code nodig.",
            "accountBound": "De aankoop via Garmin Pay is gekoppeld aan je Garmin-account en automatisch beschikbaar voor je toekomstige apparaten (indien compatibel).",
            "eliteNoKeyAndGuide": "Bij aankoop via Garmin Pay wordt geen code verzonden — de Elite-versie is direct na aankoop ontgrendeld. Meer details in de koop- en installatiehandleiding."
        },
        "vx": {
            "badge": "Alle apparaten",
            "title": "VX-versie",
            "description": "Compatibel met alle ondersteunde apparaten. Download de proefversie uit de ConnectIQ Store en activeer hier met een gekochte code.",
            "trialNote": "De VX-versie heeft een proefperiode. Daarna kun je hieronder een activatiecode kopen om te ontgrendelen.",
            "deviceBound": "Een activeringscode is gekoppeld aan je apparaat en ontgrendelt de VX-versie permanent.",
            "moreGuide": "Meer over de VX-versie, sleutels of installatie?",
            "moreGuideLink": "Lees de koop- en installatiehandleiding",
            "downloadLink": "VX-versie downloaden",
            "details": {
                "line1": "Na betaling wordt de activatiesleutel naar het e-mailadres gestuurd dat je in de volgende stap invult.",
                "line2": "Controleer of het e-mailadres klopt.",
                "line3": "Controleer na betaling je spammap; sleutel-e-mails komen daar vaak terecht.",
                "line4": "Alle betalingen worden door Paddle afgehandeld; geen account nodig.",
                "line5": "Voor ondersteuning: gebruik het contactformulier of de ConnectIQ Store-tool.",
                "line6": "Andere verzoeken kunnen niet worden verwerkt."
            }
        },
        "standalone": {
            "title": "Activatiecode kopen",
            "description": "Koop een activatiecode door hieronder je WatchfaceID in te voeren. De code wordt direct naar je gestuurd."
        },
        "checkoutOpening": "Betaling openen...",
        "info": {
            "key": "Na aankoop ontvang je een sleutel die je in je watchface-instellingen kunt invoeren.",
            "activation": "De sleutel wordt direct na betaling geactiveerd.",
            "support": "Voor vragen, neem contact op met ondersteuning.",
            "moreGuide": "Meer over aankoop en installatie"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Creditcard"
        }
    },
    "footer": {
        "tagline": "Moderne Garmin-apps met geavanceerde functies voor al je activiteiten.",
        "description": "Moderne Garmin-apps met geavanceerde functies voor al je activiteiten."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Abonneer je op de newsletter voor updates over nieuwe watchfaces, functies en acties.",
        "frequencyHint": "Ongeveer één e-mail per twee maanden. Afmelden kan altijd.",
        "emailPlaceholder": "Je e-mailadres",
        "subscribe": "Abonneren",
        "unsubscribe": "Afmelden",
        "subscribeSuccess": "Succesvol aangemeld! Controleer je e-mail.",
        "subscribeError": "Er is een fout opgetreden. Probeer het later opnieuw.",
        "unsubscribeSuccess": "Succesvol afgemeld.",
        "unsubscribeError": "Er is een fout opgetreden. Probeer het later opnieuw."
    },
    "contact": {
        "title": "Contact",
        "description": "Heb je een vraag of heb je hulp nodig? Stuur mij een bericht.",
        "emailLabel": "E-mail",
        "emailPlaceholder": "jouw@email.nl",
        "deviceLabel": "Toestel (optioneel)",
        "devicePlaceholder": "bijv. Fenix 7",
        "watchfaceLabel": "Watchface (optioneel)",
        "watchfacePlaceholder": "bijv. Horizon",
        "messageLabel": "Bericht",
        "messagePlaceholder": "Je bericht...",
        "send": "Bericht verzenden",
        "sendAnother": "Nog een bericht verzenden",
        "successTitle": "Bericht verzonden!",
        "successMessage": "Ik reageer zo snel mogelijk.",
        "error": "Er is een fout opgetreden. Probeer het opnieuw of mail direct naar dev@orcatec.net.",
        "rateLimit": "Maximaal 2 berichten per 5 minuten. Probeer het later opnieuw.",
        "consentNotice": "Door te verzenden ga je akkoord met de verwerking van je gegevens volgens mijn",
        "guidesIntro": "Heb je vragen over specifieke functies? Deze handleidingen bevatten mogelijk al het antwoord:",
        "faqIntro": "Voor veel onderwerpen is er ook een uitgebreide FAQ:",
        "faqLinkLabel": "Help en instructies openen",
        "responseTimeNotice": "Houd er rekening mee dat het in drukke periodes soms enkele dagen kan duren voordat ik kan reageren."
    },
    "fonts": {
        "title": "Lettertypen",
        "timefonts": "Tijd-lettertypen",
        "datafonts": "Gegevens-lettertypen"
    },
    "common": {
        "loading": "Laden...",
        "error": "Fout",
        "retry": "Opnieuw proberen",
        "back": "Terug",
        "close": "Sluiten",
        "save": "Opslaan",
        "cancel": "Annuleren",
        "confirm": "Bevestigen",
        "notFound": "404 – Pagina niet gevonden"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Met de Bierwandern-app volg je je wandeling en de bijvullingen die je onderweg geniet. Daarnaast is er een promille-schatting met grafiek (grove schatting) – maar neem het niet te serieus!",
        "settingsHint": "Druk op het startscherm op de menuknop van je horloge om het instellingenmenu te openen (op horloges met 2-knoppenlayout: lang op het touchscreen drukken).",
        "disclaimer": "De promille-berekening is puur een fun-metric – een algoritme dat op basis van genuttigde drankjes en lichaamsgewicht het bloedalcoholgehalte schat! Neem geen beslissingen op basis van deze waarde; hij is niet betrouwbaar en geen echte meting van alcohol!",
        "closing": "Verder wens ik je fijne wandelingen en veel plezier!",
        "support": "Bij problemen of verbeteringsvoorstellen gebruik je de knop «App Support» – bedankt."
    },
    "bodysurf": {
        "intro": {
            "title": "Wat is BodySurf?",
            "text": "BodySurf is een Garmin Connect IQ horloge-app voor bodysurfen. Met GPS detecteert de app wanneer je een golf rijdt, meet afstand en duur van elke rit en geeft een leuke titel op basis van de afgelegde afstand. Sessies worden opgeslagen als activiteiten met aparte ronden in Garmin Connect."
        },
        "gps": {
            "title": "Voor je begint – GPS",
            "text1": "Wacht op een GPS-fix voordat je een sessie start. Op het startscherm zie je \"GPS aan het zoeken\" tot er signaal is, daarna \"START om te beginnen\".",
            "text2": "Voor de beste nauwkeurigheid gebruikt de app multi-GNSS / dual-band GPS wanneer je horloge dit ondersteunt. Blijf even stil bij het water als de fix langer duurt."
        },
        "start": {
            "title": "Startscherm",
            "startBtn": "Start een nieuwe sessie zodra GPS klaar is (START = begin sessie).",
            "menuBtn": "Open instellingen: Hoe te gebruiken en Eenheden (MENU = instellingen / info).",
            "backBtn": "BACK = app afsluiten"
        },
        "during": {
            "title": "Tijdens Activiteit",
            "detect": "Ritten worden gedetecteerd door GPS snelheid automatisch. Gebruik BACK om een rit handmatig te starten/stoppen. Korte bewegingen onder ongeveer 2 meter worden genegeerd.",
            "startBtn": "START = stoppen / opslaan / hervatten",
            "backBtn": "BACK = handmatige rit aan/uit",
            "live": "Tijdens het rijden zie je de huidige afstand, een live titel en \"RIJDEN!\". Na een rit blijven titel en stats zichtbaar tot de volgende rit begint."
        },
        "stop": {
            "title": "Stopmenu",
            "resume": "Hervatten",
            "save": "Opslaan",
            "discard": "Verwerpen"
        },
        "after": {
            "title": "Na Sessie",
            "summary": "Het overzicht toont sessietijd, aantal Ritten, totale afstand en je Beste rit met titel en stats.",
            "rides": "Veeg om ritdetails te zien. Op knoppenhorloges: << DOWN rides.",
            "finished": "Daarna: Nieuwe Sessie met START of App Sluiten met TERUG."
        },
        "titles": {
            "title": "Rittitels",
            "intro": "Elke rit krijgt een leuke titel gebaseerd op afstand. Hoe langer de rit, hoe beter de titel!",
            "colDistance": "Afstand",
            "colTitle": "Titel",
            "th0": "Zeegurke",
            "th1": "Flunder",
            "th2": "Menselijk Surfboard",
            "th3": "Wellenrijder",
            "th4": "Aquaman",
            "th5": "Poseidon",
            "th6": "Neptunus",
            "th7": "Wellenbezwinger",
            "th8": "Meesterrijder",
            "th9": "Wellengod",
            "th10": "Oceaanlegende",
            "th11": "Titan der Wellen",
            "th12": "Koning van de Oceaan"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Opgeslagen sessies verschijnen in Garmin Connect met eigen velden: rittitel, ronde-afstand (meter), rondetijd (seconden) en langste rit/tijd op sessieniveau. Elke gedetecteerde rit wordt als ronde opgeslagen."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Op Instinct-horloges toont het subdisplay tijd, GPS en ritafstand. Gebruik de DOWN-knop in plaats van vegen (<< DOWN rides).",
            "menu": "\"Menu\" staat links op het startscherm. Druk op START wanneer GPS OK in het subdisplay staat."
        },
        "settings": {
            "title": "Instellingen",
            "units": "Eenheden: schakel tussen metrisch en imperiaal voor afstand en snelheid op het horloge.",
            "info": "Info: ingebouwde hulp (Hoe te gebruiken) voor knoppen tijdens activiteit, na sessie en op het startscherm."
        },
        "supportBefore": "Bij problemen of suggesties gebruik je het",
        "supportLink": "contactformulier",
        "supportAfter": " – bedankt!"
    }
};
